import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'

import { BaseTable } from 'Features/Projects/Table/BaseTable.view'

import { SiteStockFlowData } from './SiteStockFlow.types'

interface SiteStockFlowTableProps {
  data: SiteStockFlowData[]
  isLoading: boolean
}

export const SiteStockFlowTable = ({ data, isLoading }: SiteStockFlowTableProps) => {
  // const updateTableData = (changedRows: Record<string, SiteStockFlowData>) => {
  //   // TODO: Implement API call to save changes
  //   //console.log('Changes to save:', changedRows)
  // }

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'skuGroup',
        headerName: 'Sku Group',
        flex: 1,
        type: 'string',
        pinned: 'left',
      },
      {
        field: 'fromSite',
        headerName: 'From Site',
        flex: 1,
        type: 'string',
        pinned: 'left',
      },
      {
        field: 'toSite',
        headerName: 'To Site',
        flex: 1,
        type: 'string',
        pinned: 'left',
      },
      {
        field: 'allocation',
        headerName: '% allocation',
        flex: 1,
        type: 'number',
        editable: true,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return ''
          return `${value}%`
        },
      },
      {
        field: 'leadTime',
        headerName: 'Lead time',
        flex: 1,
        type: 'number',
        editable: true,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return ''
          return value
        },
      },
      {
        field: 'moq',
        headerName: 'MOQ',
        flex: 1,
        type: 'number',
        editable: true,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return ''
          return value
        },
      },
      {
        field: 'moi',
        headerName: 'MOI',
        flex: 1,
        type: 'number',
        editable: true,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return ''
          return value
        },
      },
      {
        field: 'modal',
        headerName: 'Modal',
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'costPerUnit',
        headerName: 'Cost per unit',
        flex: 1,
        type: 'number',
        editable: true,
        valueFormatter: (value) => {
          if (value === null || value === undefined) return ''
          return `$${value.toFixed(2)}`
        },
      },
      {
        field: 'uom',
        headerName: 'UOM',
        flex: 1,
        type: 'string',
        editable: true,
      },
    ]
  }, [])

  return (
    <BaseTable
      data={data}
      columns={columns}
      isLoading={isLoading}
      updateTableData={() => {}}
      uploadData={() => {}}
      isUploading={false}
      isSaving={false}
      checkBoxSelection={true}
      pinnedColumns={['skuGroup', 'fromSite', 'toSite']}
    />
  )
}
